<template>
    <div>
        <app-sub-title text="Reuniones"></app-sub-title>
        <app-contact-reports-review-filters
            @filter="onFilter"
            :authors="authors"
        />
        <app-contact-reports-review-list
            :data="data"
            @change-page="changePage"
            @see-details-report="seeDetails"
            @sort="onSort"
        />

        <!-- Inicio pop up's -->

        <app-pop-up
            :title="
                `Reunion: ${selectedReport.code} - Fecha: ${moment(
                    selectedReport.meeting_date
                ).format('DD/MM/YYYY HH:mm:ss')}`
            "
            id="see-report"
            size="extra-large"
        >
            <div slot="body">
                <b-tabs>
                    <b-tab title="Información detallada" active>
                        <b-card
                            v-if="selectedReport"
                            tag="article"
                            style="max-width: 100%;"
                            class="mb-2"
                        >
                            <div class="card-text">
                                <b-row>
                                    <b-col class="pb-3" cols="12" md="4">
                                        <h5>Cliente</h5>
                                        {{ selectedReport.client.name }}
                                    </b-col>
                                    <b-col
                                        class="pb-3"
                                        v-if="
                                            selectedReport.participants.length
                                        "
                                    >
                                        <h5>Reportado por</h5>
                                        {{ selectedReport.reported_by.name }}
                                    </b-col>
                                    <b-col class="pb-3" cols="12" md="4">
                                        <h5>Participantes</h5>
                                        <div
                                            v-for="participant in selectedReport.participants"
                                        >
                                            <div>
                                                - {{ participant.name }} ({{
                                                    participant.email
                                                }})
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col
                                        class="pb-3"
                                        v-if="selectedReport.watchers.length"
                                    >
                                        <h5>Compartido con</h5>
                                        <div
                                            v-for="watcher in selectedReport.watchers"
                                        >
                                            <div>
                                                -
                                                <a
                                                    :href="
                                                        `mailto:${watcher.user.email}`
                                                    "
                                                    >{{ watcher.user.name }} ({{
                                                        watcher.user.position
                                                            .name
                                                    }})</a
                                                >
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col class="pb-3" cols="12">
                                        <h5>Descripción de la reunión</h5>
                                        <div class="notebook">
                                            <span
                                                v-html="
                                                    selectedReport.description_formated
                                                "
                                            ></span>
                                        </div>
                                    </b-col>
                                    <b-col class="pb-3" cols="12">
                                        <h5>Notas internas</h5>
                                        <div class="notebook-blue">
                                            <span
                                                v-html="
                                                    selectedReport.internal_notes
                                                "
                                            ></span>
                                        </div>
                                    </b-col>
                                    <b-col
                                        class="pb-3"
                                        cols="12"
                                        v-if="
                                            selectedReport.petitions.length &&
                                                !selectedReport.draft
                                        "
                                    >
                                        <h5>Peticiones</h5>
                                        <div
                                            v-for="petition in selectedReport.petitions"
                                        >
                                            <div>
                                                - ({{
                                                    petition.petition_type.name
                                                }}) {{ petition.description }}
                                            </div>
                                            <br />
                                        </div>
                                    </b-col>
                                    <b-col
                                        class="pb-3"
                                        cols="12"
                                        v-if="
                                            selectedReport.petition_drafts
                                                .length && selectedReport.draft
                                        "
                                    >
                                        <h5>Peticiones borradores</h5>
                                        <div
                                            v-for="petition in selectedReport.petition_drafts"
                                        >
                                            <div>
                                                - ({{
                                                    petition.petition_type.name
                                                }}) {{ petition.description }}
                                            </div>
                                            <br />
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-card>
                    </b-tab>
                    <b-tab
                        title="Fotos"
                        v-if="!!selectedReport && selectedReport.photos.length"
                    >
                        <app-sub-title text="Fotos" />
                        <b-carousel
                            id="report-photos"
                            controls
                            indicators
                            :interval="4000"
                            v-model="slide"
                        >
                            <b-carousel-slide
                                v-for="photo in selectedReport.photos"
                                :key="photo.id"
                                :img-src="photo.photo_url"
                            />
                        </b-carousel>
                    </b-tab>
                </b-tabs>
            </div>
        </app-pop-up>
        <!-- Fin pop up's -->
    </div>
</template>

<script>
import ContactReportsReviewFilters from './ContactReportsReviewFilters/ContactReportsReviewFilters.vue'
import ContactReportsReviewList from './ContactReportsReviewList/ContactReportsReviewList.vue'
import contactsRepository from '../../../../../repositories/contacts.repository.js'
export default {
    components: {
        appContactReportsReviewFilters: ContactReportsReviewFilters,
        appContactReportsReviewList: ContactReportsReviewList,
    },
    data() {
        return {
            data: {},
            filters: {},
            page: 1,
            selectedReport: '',
            slide: 1,
            sort: {
                sortBy: 'meeting_date',
                sortDir: 'desc',
            },
            authors: [],
        }
    },
    methods: {
        loadReports() {
            const cr = { ...contactsRepository }
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
                state: 0,
            }
            cr.getReports(filters, this.page)
                .then(data => (this.data = data))
                .catch(error =>
                    toastr.error('Ocurrió un error al cargar los reportes')
                )
        },
        loadAuthors() {
            const cr = { ...contactsRepository }
            cr.getAuthorsOfContactReports()
                .then(data => (this.authors = data))
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar los autores de los reportes'
                    )
                )
        },
        onFilter(filters) {
            this.filters = filters
            this.loadReports()
        },
        changePage(page) {
            this.page = page
            this.loadReports()
        },
        seeDetails(report) {
            this.selectedReport = report
            this.$bus.$emit('see-report.open')
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadReports()
        },
        initialize() {
            this.loadReports()
            this.loadAuthors()
        },
    },
    created() {
        this.initialize()
    },
}
</script>
